import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, errMsg } from "@/lib/api";
import { fmt } from "@/lib/status";
import { usePractice } from "@/pages/StaffApp";

export default function SuperAdmins() {
  const me = usePractice()?.me;
  const [rows, setRows] = useState([]);
  const [email, setEmail] = useState("");
  const load = () => api.get("/enterprise/super-admins").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const add = async () => { try { await api.post("/enterprise/super-admins", { email }); toast.success("Super Admin added (audited)"); setEmail(""); load(); } catch (e) { toast.error(errMsg(e)); } };
  const remove = async (r) => {
    if (!window.confirm(`Remove Super Admin access from ${r.email}? Their organization access is not changed.`)) return;
    try { await api.delete(`/enterprise/super-admins/${r.user_id}`); toast.success("Super Admin removed"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4 max-w-3xl" data-testid="super-admins">
      <div className="bg-white border rounded-xl p-4 space-y-2">
        <p className="text-sm font-semibold">Add a Super Admin</p>
        <p className="text-xs text-slate-500">The person must already have an ACE eSIGN sign-in. Super Admins manage organizations and enterprise members but do not see patient records unless an organization adds them.</p>
        <div className="flex gap-2"><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@acehcs.com" className="max-w-sm" data-testid="super-add-email" />
          <Button className="btn-brand" disabled={!email.trim()} onClick={add} data-testid="super-add-btn">Add</Button></div>
      </div>
      <Table className="bg-white border rounded-xl"><TableHeader><TableRow><TableHead>Email</TableHead><TableHead>Name</TableHead><TableHead>Source</TableHead><TableHead /></TableRow></TableHeader>
        <TableBody>{rows.map((r) => (
          <TableRow key={r.email} data-testid={`super-row-${r.email}`}>
            <TableCell className="text-sm">{r.email}</TableCell><TableCell className="text-sm">{r.name || <span className="text-slate-400">Not signed in yet</span>}</TableCell>
            <TableCell className="text-xs">{r.fixed ? <span className="inline-flex items-center gap-1 text-slate-600"><Lock className="w-3 h-3" />Permanent (ADMIN_EMAIL setting)</span> : <span>Added by {r.added_by || "-"}{r.added_at && `, ${fmt(r.added_at)}`}</span>}</TableCell>
            <TableCell className="text-right">{!r.fixed && r.user_id !== me?.user_id && <Button size="sm" variant="outline" className="text-red-700" onClick={() => remove(r)} data-testid={`super-remove-${r.email}`}>Remove</Button>}</TableCell>
          </TableRow>))}</TableBody></Table>
    </div>
  );
}
